<div class="header">
  <span class="header__title">{{ title }}</span>
  <div class="header__close" (click)="actions()">
    <img
      class="header__close__icon-close"
      src="https://cdn.mango-soft.com/mango-core/close.svg"
      alt=""
    />
    <span class="header__close__icon-close-mb"> &#8249;</span>
  </div>
</div>
